import React from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import { RocketLaunchOutlined as RocketIcon } from "@mui/icons-material";
import { Path, LOTTERY_NAMES } from "../../../../../static/Constants";
import { NoData } from "../../../../Components/ui";

const MissileEmptyState = ({
  lotteryId,
  title,
  subtitle,
  onRetry,
}) => {
  const history = useHistory();

  const emptyTitle =
    title ||
    (lotteryId
      ? `${LOTTERY_NAMES.ROCKETBET} #${lotteryId} Unavailable`
      : `No Active ${LOTTERY_NAMES.ROCKETBET} Found`);

  const emptySubtitle =
    subtitle ||
    (lotteryId
      ? "This missile lottery is either concluded, invalid, or could not be loaded from the blockchain."
      : "There are currently no active missile lotteries available. Explore our live game arenas!");

  return (
    <Box sx={{ py: 6, px: 2 }}>
      <NoData
        title={emptyTitle}
        subtitle={emptySubtitle}
        icon={<RocketIcon sx={{ fontSize: 36 }} />}
        actionText={`Explore All ${LOTTERY_NAMES.ROCKETBET}`}
        onAction={() => history.push(Path.allmissilelottery)}
        maxWidth={540}
        minHeight={320}
      />
    </Box>
  );
};

export default MissileEmptyState;
